import React, { FC, Fragment } from 'react'
import {
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerFooter,
  DrawerHeader,
  Heading,
  Text,
  Stack,
} from '@chakra-ui/react'

import { Empty, Loader } from 'components'

import UnifiedPersonFilterTags from 'CitizenProfile/components/CitizenFilterTags'
import CustomFormUnifiedPersonCardToSelect from './components/CustomFormUnifiedPersonCardToSelect'
import { useCustomFormUnifiedPersonSelectionDrawerManager } from '../../contexts/CustomFormUnifiedPersonSelectionDrawerManager/Provider'

type Props = {
  onClose: () => void
}

const SelectUnifiedPersonOnCustomForm: FC<Props> = ({ onClose }) => {
  const { invalidUnifiedPerson, loadingUnifiedPeople, unifiedPeople, setView, filter, setFilter } =
    useCustomFormUnifiedPersonSelectionDrawerManager()

  return (
    <>
      <DrawerCloseButton />

      <DrawerHeader>
        <Text>Pessoas unificadas disponíveis</Text>
        <Heading color="primary">Selecione uma pessoa unificada</Heading>
      </DrawerHeader>

      <DrawerBody overflowY="auto">
        <UnifiedPersonFilterTags px={4} pb={4} citizenFilter={filter} setCitizenFilter={setFilter} />

        {loadingUnifiedPeople ? (
          <Loader text={'Carregando pessoas unificadas disponíveis'} />
        ) : (
          <Fragment>
            {invalidUnifiedPerson ? (
              <Empty
                illustration="EmptyDrawer"
                title="As informações passadas não são suficientes."
                description="Você precisa inserir mais informações para selecionar uma pessoa específica."
              >
                <Button onClick={() => setView('SEARCH_UNIFIED_PERSON')}>Pesquisar novamente</Button>
              </Empty>
            ) : (
              <Fragment>
                {unifiedPeople.length > 0 ? (
                  <Stack>
                    {unifiedPeople.map((unifiedPerson) => (
                      <CustomFormUnifiedPersonCardToSelect
                        key={unifiedPerson.id}
                        unifiedPerson={unifiedPerson}
                        onClose={onClose}
                      />
                    ))}
                  </Stack>
                ) : (
                  <Empty title={'Nenhuma pessoa unificada encontrada'} description="Sua busca não retornou registros" />
                )}
              </Fragment>
            )}
          </Fragment>
        )}
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={() => setView('SEARCH_UNIFIED_PERSON')}>
          Voltar
        </Button>

        <Button onClick={onClose}>Concluir</Button>
      </DrawerFooter>
    </>
  )
}

export default SelectUnifiedPersonOnCustomForm
